import { render, staticRenderFns } from "./BusinessItemCategories.vue?vue&type=template&id=1a4cef84"
import script from "./BusinessItemCategories.vue?vue&type=script&lang=js"
export * from "./BusinessItemCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports